import React from 'react';

import { TileLayer, LayerGroup, LayersControl } from 'react-leaflet';
const { BaseLayer, Overlay } = LayersControl

const MapLayers = (props) => {
  return (
    <LayersControl position="topright">
      {/* <BaseLayer name="OpenStreetMap.Mapnik">
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      </BaseLayer>
      <BaseLayer name="OpenStreetMap.BlackAndWhite">
        <TileLayer url="https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png" />
      </BaseLayer> */}
      <BaseLayer checked name="Carto.Light">
        <TileLayer url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
        attribution="&copy; &lt;a href=&quot;http://www.openstreetmap.org/copyright&quot;&gt;OpenStreetMap&lt;/a&gt; contributors, &copy; &lt;a href=&quot;https://carto.com/attribution&quot;&gt;CARTO&lt;/a&gt;" />
      </BaseLayer>
      {/* <BaseLayer name="Here.Maps">
        <TileLayer url="https://1.base.maps.api.here.com/maptile/2.1/maptile/newest/normal.day/{z}/{x}/{y}/256/png8?app_id=AD0e4k9xijdp3eBC50dD&app_code=OL06ks8EEMsX-4a0Wm2Dsw" />
      </BaseLayer>
      <BaseLayer name="Here.Maps.Hybrid">
        <TileLayer url="https://1.aerial.maps.api.here.com/maptile/2.1/maptile/newest/hybrid.day/{z}/{x}/{y}/256/jpg?app_id=AD0e4k9xijdp3eBC50dD&app_code=OL06ks8EEMsX-4a0Wm2Dsw" />
      </BaseLayer>
      <BaseLayer name="Here.Maps.XBase">
        <TileLayer url="https://1.base.maps.api.here.com/maptile/2.1/xbasetile/newest/normal.day/{z}/{x}/{y}/256/jpg?app_id=AD0e4k9xijdp3eBC50dD&app_code=OL06ks8EEMsX-4a0Wm2Dsw" />
      </BaseLayer>
      <BaseLayer name="Here.Maps.Base">
        <TileLayer url="https://1.base.maps.api.here.com/maptile/2.1/basetile/newest/normal.day/{z}/{x}/{y}/256/jpg?app_id=AD0e4k9xijdp3eBC50dD&app_code=OL06ks8EEMsX-4a0Wm2Dsw" />
      </BaseLayer>
      <BaseLayer name="Stamen.Maps.Watercolor">
        <TileLayer url="http://tile.stamen.com/watercolor/{z}/{x}/{y}.jpg" />
      </BaseLayer>
      <BaseLayer name="Stamen.Maps.Toner">
        <TileLayer url="http://tile.stamen.com/toner/{z}/{x}/{y}.png" />
      </BaseLayer>
      <BaseLayer name="Stamen.Maps.Terrain">
        <TileLayer url="http://tile.stamen.com/terrain/{z}/{x}/{y}.jpg" />
      </BaseLayer> */}
{/* 
      <Overlay name="Labels">
        <LayerGroup>
          <TileLayer url="https://1.base.maps.api.here.com/maptile/2.1/labeltile/newest/normal.day/{z}/{x}/{y}/256/png8?app_id=AD0e4k9xijdp3eBC50dD&app_code=OL06ks8EEMsX-4a0Wm2Dsw" />
        </LayerGroup>
      </Overlay>
      <Overlay name="Lines">
        <LayerGroup>
          <TileLayer url="https://1.base.maps.api.here.com/maptile/2.1/linetile/newest/normal.day/{z}/{x}/{y}/256/png8?app_id=AD0e4k9xijdp3eBC50dD&app_code=OL06ks8EEMsX-4a0Wm2Dsw" />
        </LayerGroup>
      </Overlay>
      <Overlay name="Traffic">
        <LayerGroup>
          <TileLayer url="https://1.traffic.maps.api.here.com/maptile/2.1/flowtile/newest/normal.day/{z}/{x}/{y}/256/png8?app_id=AD0e4k9xijdp3eBC50dD&app_code=OL06ks8EEMsX-4a0Wm2Dsw" />
        </LayerGroup>
      </Overlay> */}
    </LayersControl>
  )
}

export { MapLayers as default }